import { render, staticRenderFns } from "./DeliveryTotal.vue?vue&type=template&id=09e7ac92&"
import script from "./DeliveryTotal.vue?vue&type=script&lang=js&"
export * from "./DeliveryTotal.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTotal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports